import { useState } from 'react';
import { Link as RouterLink, useNavigate} from "react-router-dom";
import { validationMessage } from '../../../configure/validationConfig';
import { getCurrentDate } from '../../../utils/timeUtil';
import CustomAPICalls from '../../../api/public/CustomAPICalls';
import SnackbarComponent from '../../../components/CustomBarComponent';
import CustomLabelInput from '../../../components/Custom/CustomLabelInput';

import {
    Button,
    Grid,
    Link,
    Stack,
} from "@mui/material";

import * as Yup from "yup";
import { Formik } from "formik";

import { useTheme } from '@mui/material/styles';
import Processing from '../../../components/Processing';


const allowedDomains = ["@assaabloy.com", "@qburst.com"];
 
const isValidEmailDomain = (value) => {
    return allowedDomains.some((domain) => value.toLowerCase().endsWith(domain));
};


const VerifyInvitationCode = () => {
    const theme = useTheme();
    const LOADING_COLOR= theme.palette.action.disabled;
    const [loading, setLoading] = useState(false);
    const [isError, setIsError] = useState(false);

    const navigate = useNavigate();

    const [snackbarState, setSnackbarState] = useState({
        open: false,
        message: "",
    }); 

    return (
        <>
        {Processing(loading)}
        <SnackbarComponent
            snackbarState={snackbarState}
            setSnackbarState={setSnackbarState}
        />
            <Formik
                initialValues={{
                email: "",
                inviteCode: "", 
                }}
                validationSchema={Yup.object().shape({
                email: Yup.string()
                    .email("Please enter a valid email")
                    .max(255, "Email address must be maximum 255 characters long")
                    .required(validationMessage.ENTER_EMAIL)
                    .test("valid-domain", "Invalid email domain", (value) => {
                        return isValidEmailDomain(value);
                    })
                    ,
                inviteCode: Yup.string()
                    .required(validationMessage.ENTER_INVITE_CODE),
                })}

                onSubmit={async (values, { setErrors, setStatus, setSubmitting }) => {
                    setStatus({ success: false });
                    setLoading(true);
                    values["email"] = values["email"].toLowerCase();
                    values["otpTimeStamp"] = getCurrentDate();
                    values["userType"] = "CamAdmin";
                    values["otp"] = values["inviteCode"];
                    try{
                        const verifyOTPInvite = await(CustomAPICalls(values , "/otp/verifyOtp"));
                        const verifiedData = JSON.parse(verifyOTPInvite.data.body);
     
                        if(!verifiedData.token){
                            throw new Error(verifiedData.message || "OTP verification failed.");
                        }

                        const obj = {
                            "token" : verifiedData.token,
                            "email" : values?.email.toLowerCase() ?? "",
                        }
                        
                        const getInfo = await(CustomAPICalls(obj, "/admins/getAdminSignup"));
                        
                        obj["firstname"]= getInfo.data.FirstName || "";
                        obj["lastname"]=  getInfo.data.LastName || "";
                        
                        if(getInfo.status === 200){
                            navigate('/register', {state: obj});
                        }else{
                            throw new Error( "Error with sign up"); 
                        }
                    }catch(error){
                        setIsError(true);
                        setSnackbarState({ open: true, message: "Error: " + error.message || "Error with sign up "}); 
                    }
                    finally{
                        setLoading(false);
                    }
                }}
            >
                {({
                handleSubmit,
                isSubmitting,
                }) => (
                <form noValidate onSubmit={handleSubmit}>
                    <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Stack spacing={1}>
                            <CustomLabelInput
                                name="email"
                                placeholder="Enter your email"
                                label="Email"
                                type="text"
                                disabled={loading}
                                isError={isError}
                                maxLength={255}
                            />
                        </Stack>
                    </Grid>
                    <Grid item xs={12}>
                        <Stack spacing={1}>
                            <CustomLabelInput
                                name="inviteCode"
                                placeholder="Enter invite code"
                                label="Invite code"
                                type="text" 
                                disabled={loading}
                                isError={isError}
                            />
                        </Stack>
                    </Grid>
                    
                    <Grid item xs={12}>
                        <Button
                            disableElevation
                            disabled={isSubmitting}
                            fullWidth
                            size="large"
                            type="submit"
                            variant="contained"
                            color="primary"
                        >
                            Verify
                        </Button>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                        justifyContent="center"
                        alignItems="center"
                        display="flex"
                    >
                        <Link
                            component={RouterLink}
                            variant="h6"
                            to="/login"
                            disabled={loading}
                            onClick= {(e)=> loading && e.preventDefault()}
                            sx= {{
                                color: !loading ? "primary.darker" : LOADING_COLOR,
                            }}
                            >
                            {" "}
                            I already have an account
                        </Link>
                    </Grid>
                    </Grid>
                </form>
                )}
            </Formik>
        </>
    )
}

export default VerifyInvitationCode;